import { apiCall, ApiConfig } from '../../config/api'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { GET_TYPE_PROCESS } from '../types/typeProcessActionsTypes'
import { TypeProcess } from '../../interfaces/TypeProcess/TypeProcess'
import { getTypeProcessAction } from '../actions/typeProcessActions'

export function* getTypeProcessAsync() {
  try {
    const { status, data }: AxiosResponse<TypeProcess[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeProcessApi}/Get`
    )
    if (status === 200) {
      yield put(getTypeProcessAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeProcessAction([], serverError.message))
  }
}

export function* watchGetTypeProcessAsync() {
  yield takeEvery(GET_TYPE_PROCESS, getTypeProcessAsync)
}
